import { render, staticRenderFns } from "./LengkuProject.vue?vue&type=template&id=21459fff"
import script from "./LengkuProject.vue?vue&type=script&lang=js"
export * from "./LengkuProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports